var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "address-selected" }, [
    _c("span", { staticClass: "address-label" }, [
      _vm._v("\n    " + _vm._s(_vm._f("name")(_vm.address)) + "\n  ")
    ]),
    _vm._v(" "),
    _c("span", { staticClass: "address-street" }, [
      _vm._v("\n    " + _vm._s(_vm._f("streetAddress")(_vm.address)) + "\n  ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1201c6e9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1201c6e9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Components/Scheduler/Steps/Address/SelectedAddress.vue
// module id = null
// module chunks = 